import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";
import {
  KatalogRah,
  MonitoringRahInput,
  RekamAsuhanHemodialisis,
  RekamAsuhanHemodialisisPerRegister,
  RekamAsuhanHemodialisisUpdate
} from "@/types/rekam_asuhan_hemodialisis";

let katalogCache: Promise<KatalogRah> | null = null;

function fail(err) {
  ErrorAlert.showErrorAlert(err);

  return Promise.reject(err);
}

function katalog(): Promise<KatalogRah> {
  if (!katalogCache) {
    katalogCache = http
      .getData("/rekam-asuhan-hemodialisis/katalog")
      .then(response => response.data.data as KatalogRah)
      .catch(err => {
        katalogCache = null;

        return fail(err);
      });
  }

  return katalogCache;
}

async function getByRegister(
  registerId: string,
  rm: string
): Promise<RekamAsuhanHemodialisisPerRegister> {
  const response = await http
    .getDataParam(`/register/${registerId}/rekam-asuhan-hemodialisis`, {
      params: { rm }
    })
    .catch(fail);

  return {
    data: response.data.data || [],
    riwayat: response.data.riwayat || []
  };
}

async function create(data: {
  register_id: string;
  pasien_rm: string;
  unit_id: string | null;
}): Promise<RekamAsuhanHemodialisis> {
  const response = await http
    .postData("/rekam-asuhan-hemodialisis", data)
    .catch(fail);

  return response.data.data;
}

async function update(
  id: number,
  data: RekamAsuhanHemodialisisUpdate
): Promise<RekamAsuhanHemodialisis> {
  const response = await http
    .putData(`/rekam-asuhan-hemodialisis/${id}`, data)
    .catch(fail);

  return response.data.data;
}

async function storeMonitoring(
  id: number,
  data: MonitoringRahInput
): Promise<RekamAsuhanHemodialisis> {
  const response = await http
    .postData(`/rekam-asuhan-hemodialisis/${id}/monitoring`, data)
    .catch(fail);

  return response.data.data;
}

async function updateMonitoring(
  id: number,
  rowId: number,
  data: MonitoringRahInput
): Promise<RekamAsuhanHemodialisis> {
  const response = await http
    .putData(`/rekam-asuhan-hemodialisis/${id}/monitoring/${rowId}`, data)
    .catch(fail);

  return response.data.data;
}

async function deleteMonitoring(
  id: number,
  rowId: number
): Promise<RekamAsuhanHemodialisis> {
  const response = await http
    .deleteData(`/rekam-asuhan-hemodialisis/${id}/monitoring/${rowId}`)
    .catch(fail);

  return response.data.data;
}

async function signPerawat(
  id: number,
  password: string
): Promise<RekamAsuhanHemodialisis> {
  const response = await http.postData(
    `/rekam-asuhan-hemodialisis/${id}/ttd-perawat`,
    { password }
  );

  return response.data.data;
}

async function signDokter(
  id: number,
  password: string
): Promise<RekamAsuhanHemodialisis> {
  const response = await http.postData(
    `/rekam-asuhan-hemodialisis/${id}/ttd-dokter`,
    { password }
  );

  return response.data.data;
}

async function signDokterCatatan(
  id: number,
  password: string
): Promise<RekamAsuhanHemodialisis> {
  const response = await http.postData(
    `/rekam-asuhan-hemodialisis/${id}/ttd-dokter-catatan`,
    { password }
  );

  return response.data.data;
}

async function destroy(id: number): Promise<void> {
  await http.deleteData(`/rekam-asuhan-hemodialisis/${id}`).catch(fail);
}

async function openPdf(id: number): Promise<void> {
  const tab = window.open("", "_blank");

  try {
    const response = await http.getDataParam(
      `/rekam-asuhan-hemodialisis/${id}/pdf`,
      { responseType: "blob" }
    );
    const url = URL.createObjectURL(
      new Blob([response.data as BlobPart], { type: "application/pdf" })
    );

    if (tab) {
      tab.location.href = url;
    } else {
      window.open(url, "_blank");
    }

    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) {
      tab.close();
    }

    return fail(err);
  }
}

export default {
  katalog,
  getByRegister,
  create,
  update,
  storeMonitoring,
  updateMonitoring,
  deleteMonitoring,
  signPerawat,
  signDokter,
  signDokterCatatan,
  destroy,
  openPdf
};
